import React from 'react';

function Register() {
    return (
        <div>
           ok 
        </div>
    );
}

export default Register;